import { Select, Tag, Button } from "antd";
import React, { useEffect, useState } from "react";
import { DragablleIcon } from "../../../Assets/campagin/sectionProgress/svgs";
import API_MANAGER from "../../../API";
import { PickListMockData } from "../../../utils/constant";

function RequirementItemSearchable({
  title,
  handelSelect,
  type,
  reqDisabled,
  selected,
  tags,
  unique_id,
}) {
  const dropDownRenderDocument = [
  "INDUCTION",
  "SKILL",
];
  const [selectedValues, setSelectedValues] = useState([]);
  const [options, setoptions] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [isCreating, setIsCreating] = useState(false);

  const tagOption = options?.map((item) => {
  
    const index = unique_id;
    if (reqDisabled?.[index]) {
     
      if (!reqDisabled?.[index]?.find((req) => req === item?.id)) {
       
        return {
          value: item?.id,
          label: item?.name,
        };
      } else {
       
        return {
          value: item?.id,
          label: item?.name,
          disabled: true,
        };
      }
    } else {
     
      return {
        value: item?.id,
        label: item?.name,
      };
    }
  });
  const mode = PickListMockData?.find(
    (feat) =>
      feat?.title?.toUpperCase() === title?.toUpperCase() &&
      feat?.mode === "single"
  )
    ? "single"
    : "multiple";
  const getTagsOptions = async () => {
    try {
      const res = await API_MANAGER.getTags(`${tags}&sort=name`);
      setoptions(res?.data?.data?.tags);
    } catch (err) {}
  };

  const createTagOption = async (tagName) => {
    setIsCreating(true);
    try {
      const data = { name: tagName, type: tags };
      const res = await API_MANAGER.createTags(data);
      if (res?.data?.isSuccess) {
        const newTag = res.data.data;
        if (newTag) {
          // Ensure the new tag is available immediately to prevent ID flashing
          setoptions((prevOptions) => {
            const exists = prevOptions?.some((opt) => opt?.id === newTag?.id);
            return exists ? prevOptions : [...(prevOptions || []), newTag];
          });
          const newSelectedValues = mode === "multiple" 
            ? [...selectedValues, newTag.id]
            : [newTag.id];
          setSelectedValues(newSelectedValues); 
          handelSelect(newSelectedValues, type, unique_id, mode);
        }
      }
    } catch (err) {
      console.error("Error creating tag:", err);
    } finally {
      setIsCreating(false);
      setSearchValue("");
    }
  };

  const handleChange = (values) => {
    setSelectedValues(values);
    handelSelect(values, type, unique_id, mode);
  };

  const handleSearch = (value) => {
    setSearchValue(value);
  };

  const handleCreateTag = () => {
    if (searchValue.trim()) {
      createTagOption(searchValue.trim());
    }
  };

 
  const searchValueExists = options?.some(option => 
    option.name?.toLowerCase() === searchValue?.toLowerCase()
  );


  const filteredOptions = tagOption?.filter(option => 
    option.label?.toLowerCase().includes(searchValue?.toLowerCase())
  );

  useEffect(() => {
    getTagsOptions();
  }, [isCreating]);
  
  useEffect(() => {
    if (selected?.length > 0) {
      setSelectedValues(selected);
    }
  }, [selected]);

  const filterOption = (input, option) =>{
    return (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
  }
  const dropdownRender = (menu) => (
    <div>
      {menu}
      {searchValue && !searchValueExists && searchValue.trim() && (
        <div style={{ padding: '8px', borderTop: '1px solid #f0f0f0' }}>
          <Button
            type="text"
            icon="+"
            onClick={handleCreateTag}
            loading={isCreating}
            style={{ width: '100%', textAlign: 'left' }}
          >
            Click to create a pick list value "{searchValue}" 
          </Button>
        </div>
      )}
    </div>
  );

  return (
    <div className="searchable-requirement-item">
      <div className="draggable-icon">
        <DragablleIcon />
      </div>
      <Select
        mode={mode === "multiple" ? "multiple" : ""}
        className={mode === "multiple" ? "multiple_selected_add" : ""}
        allowClear
        style={{
          width: "100%",
        }}
        // defaultValue={selected}
        value={selectedValues}
        showSearch
        filterOption={filterOption}
        placeholder={`${title}`}
        onChange={(e) => handleChange(e)}
        onSearch={handleSearch}
        dropdownRender={dropDownRenderDocument.includes(tags)? dropdownRender:undefined}
        maxTagCount={2}
        maxTagPlaceholder={<div>+{selectedValues?.length - 2} more</div>}
        placement="bottomLeft"
        tagRender={(props) => {
          const { value, closable, onClose, label } = props;
          const isSelected = selectedValues?.includes(value);
          return (
            <Tag
              closable={closable}
              onClose={(e) => {
                e.preventDefault();
                onClose();
                const newSelectedValues = selectedValues?.filter(
                  (val) => val !== value
                );
                setSelectedValues(newSelectedValues);
                handelSelect(newSelectedValues, type, unique_id, mode); // <- add this

              }}
              style={{
                background: isSelected ? "#FAE7B6" : "transparent",
                padding: isSelected ? "2px 5px" : "",
              }}
            >
              {label}
            </Tag>
          );
        }}
        options={filteredOptions}
      />
    </div>
  );
}

export default RequirementItemSearchable;
